import { createAction, props } from '@ngrx/store';
import { ListarEdicoesParaCalendarioInputDto } from 'src/app/domain/DTOs/input/jornal/listar-edicoes-para-calendario-input.dto';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { ListarEdicoesParaCalendarioOutputDto } from 'src/app/domain/DTOs/output/jornal/listar-edicoes-para-calendario-output.dto';

const actionName = "[ listarEdicoesCalendario ] listarEdicoesCalendario";

export const listarEdicoesCalendario = createAction(
  actionName,
  props<{ listarEdicoesCalendarioInputDto: ListarEdicoesParaCalendarioInputDto}>()
);

export const listarEdicoesCalendarioSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<ListarEdicoesParaCalendarioOutputDto[]> }>()
);

export const listarEdicoesCalendarioFinish = createAction(
  `${actionName} - Concluir`
);
